module.exports = __webpack_public_path__ + "img/defaultHead.65ff4f3d.png";